import React from "react";
import { motion } from "framer-motion";

const EASE = [0.25, 0.1, 0.25, 1];

export function FadeIn({
    children,
    delay = 0,
    duration = 0.7,
    x = 0,
    y = 30,
    as = "div",
    className = "",
    once = true,
    ...rest
}) {
    const Comp = motion[as] || motion.div;
    return (
        <Comp
            initial={{ opacity: 0, x, y }}
            whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once, margin: "50px", amount: 0 }}
            transition={{ duration, delay, ease: EASE }}
            className={className}
            {...rest}
        >
            {children}
        </Comp>
    );
}
